// Lib Imports
import React from 'react';
import { Box, Text } from 'grommet';
const Privacy = () => {
  return /*#__PURE__*/React.createElement(Box, {
    background: "white",
    flex: "grow",
    pad: {
      top: '100px'
    }
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "column",
    gap: "large",
    pad: {
      vertical: 'medium',
      horizontal: 'xxlarge'
    }
  }, /*#__PURE__*/React.createElement(Box, {
    alignSelf: "center",
    border: {
      color: 'brand',
      size: 'medium',
      style: 'solid',
      side: 'bottom'
    },
    margin: "medium"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "24px",
    margin: "small"
  }, "Privacy Policy")), /*#__PURE__*/React.createElement(Box, {
    direction: "row",
    justify: "between",
    gap: "medium",
    margin: {
      vertical: 'large',
      horizontal: 'medium'
    }
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "column",
    gap: "small"
  }, /*#__PURE__*/React.createElement(Text, {
    color: "#444444",
    alignSelf: "start",
    margin: {
      vertical: 'small'
    },
    size: "15px"
  }, "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English."), /*#__PURE__*/React.createElement(Text, {
    color: "brand",
    alignSelf: "start",
    margin: {
      top: 'large',
      bottom: 'small'
    },
    size: "17px"
  }, "What we collect"), /*#__PURE__*/React.createElement(Text, {
    color: "#444444",
    alignSelf: "start",
    margin: {
      vertical: 'small'
    },
    size: "15px"
  }, "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English."), /*#__PURE__*/React.createElement(Text, {
    color: "#444444",
    alignSelf: "start",
    margin: {
      vertical: 'small'
    },
    size: "15px"
  }, "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English."), /*#__PURE__*/React.createElement(Text, {
    color: "brand",
    alignSelf: "start",
    margin: {
      top: 'large',
      bottom: 'small'
    },
    size: "17px"
  }, "Cookies"), /*#__PURE__*/React.createElement(Text, {
    color: "#444444",
    alignSelf: "start",
    margin: {
      vertical: 'small'
    },
    size: "15px"
  }, "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English."), /*#__PURE__*/React.createElement(Text, {
    color: "#444444",
    alignSelf: "start",
    margin: {
      vertical: 'small'
    },
    size: "15px"
  }, "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English."), /*#__PURE__*/React.createElement(Text, {
    color: "brand",
    alignSelf: "start",
    margin: {
      top: 'large',
      bottom: 'small'
    },
    size: "17px"
  }, "Web Beacons"), /*#__PURE__*/React.createElement(Text, {
    color: "#444444",
    alignSelf: "start",
    margin: {
      vertical: 'small'
    },
    size: "15px"
  }, "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English."), /*#__PURE__*/React.createElement(Text, {
    color: "#444444",
    alignSelf: "start",
    margin: {
      vertical: 'small'
    },
    size: "15px"
  }, "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English.")))));
};
export default Privacy;